<div class="error-popup" *ngIf="show">
    <div class="error-popup-content">
        <span class="error-popup-close" (click)="closePopup()">&times;</span>
        <p>{{ errorMessage }}</p>
    </div>
</div>